import React from 'react';
import { Route } from 'react-router-dom';
import VideoPageRoute from './VideoPageRoute';

const basePath = '/v2/video';

export default (
  <Route path={`${basePath}/:videoId`}>
    <VideoPageRoute />
  </Route>
);
